import { supabase } from '../lib/supabase';

interface TableSchema {
  table_name: string;
  columns: {
    column_name: string;
    data_type: string;
    is_nullable: string;
    column_default: string | null;
  }[];
}

export async function exportDatabase() {
  try {
    // Get schema information
    const { data: schema, error: schemaError } = await supabase
      .rpc('get_schema_info');

    if (schemaError) throw schemaError;

    // For each table, get its data
    const tables = await Promise.all(schema.map(async (table: TableSchema) => {
      const { data, error } = await supabase
        .from(table.table_name)
        .select('*');

      if (error) throw error;

      return {
        name: table.table_name,
        schema: table.columns,
        data: data || []
      };
    }));

    // Create export object
    const exportData = {
      version: '1.0',
      timestamp: new Date().toISOString(),
      tables
    };

    // Convert to JSON string
    const jsonString = JSON.stringify(exportData, null, 2);

    // Create and download file
    const blob = new Blob([jsonString], { type: 'application/json' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `database_export_${new Date().toISOString().split('T')[0]}.json`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

    return true;
  } catch (err) {
    console.error('Error exporting database:', err);
    return false;
  }
}